import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './stores/store';

import AuthenticateUser from './components/AuthenticateUser';
import AppInitWrapper from './components/AppInitWrapper';
import './i18n';

import '@amzn/katal-components/styles.css';
import './styles/index.scss';
import { Amplify, Auth } from 'aws-amplify';
import { Spinner } from '@amzn/awsui-components-react';

// The Suspense component causes React to display the fallback KatSpinner until
// the i18n translation strings have been loaded.

console.log(`index.tsx`);
console.log('Stage is ' + 'prod');
console.log('AWS_REGION is ' + 'us-east-1');
console.log('IDENTITY_POOL_DOMAIN is ' + 'gso-silenciov2-prod.auth.us-east-1.amazoncognito.com');
console.log('IDENTITY_POOL_ID is ' + 'us-east-1:410f6c6e-981d-4737-9527-c8cb27137104');
console.log('USER_POOL_ID is ' + 'us-east-1_Es4c83zgX');

// @ts-ignore because this is a replacement var
if ('prod' == 'beta' || 'prod' == 'gamma') {
  Amplify.Logger.LOG_LEVEL = 'DEBUG';
}

const callbackUrl = window.location.origin;
const config = {
  oauth: {
    domain: 'gso-silenciov2-prod.auth.us-east-1.amazoncognito.com',
    scope: ['openid'],
    redirectSignIn: callbackUrl,
    redirectSignOut: callbackUrl,
    responseType: 'code',
  },
  // Cognito
  aws_cognito_identity_pool_id: 'us-east-1:410f6c6e-981d-4737-9527-c8cb27137104',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_Es4c83zgX',
  aws_user_pools_web_client_id: '5jjrfpm2opo1a4sp3d3le1usiq',
  // AppSync
  aws_appsync_graphqlEndpoint: 'https://api.prod.silencio.gso.amazon.dev/graphql',
  aws_appsync_region: 'us-east-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  API: {
    graphql_endpoint: 'https://api.prod.silencio.gso.amazon.dev/graphql',
    graphql_headers: async () => ({
      Authorization: (await Auth.currentAuthenticatedUser())
        .getSignInUserSession()
        .getIdToken()
        .getJwtToken(),
    }),
  },
};
Amplify.configure(config);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
        <AppInitWrapper>
          <React.Suspense fallback={<Spinner size='large' />}>
            <AuthenticateUser />
          </React.Suspense>
        </AppInitWrapper>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);